import React, { FC } from 'react';
import useRootSelector from 'common/hooks/useRootSelector';
import { PeakModuleForNewPersonType } from 'common/interfaces/steps';
import {
  DocumentType,
  IPersonDocumentGroupItemImt,
} from 'common/components/PersonProfile/interfaces';
import { SignContractStepContainer } from 'common/containers';
import { DialogComponent } from 'common/components/index';
import { StepContext } from 'common/createContext/stepContext';
import * as actions from 'common/components/PersonProfile/state/actions';
import { useAppDispatch } from 'store/hooks';
import { AlertCondition } from 'common/interfaces/alerts';
import { PeakModules } from 'common/constants/peakModules';
import { useCombinePrintLoading } from 'common/hooks/useCombinePrintLoading';
import { selectPersonDocumentHTMLLoading } from 'common/components/PersonProfile/state/selectors';
import { isMobile } from 'common/utils/device.utils';
import SignatureContextProvider from 'common/components/SignatureContextProvider/SignatureContextProvider';

interface ISignDocumentModal {
  isOpen: boolean;
  document: IPersonDocumentGroupItemImt;
  onClose: () => void;
  module: PeakModuleForNewPersonType;
  personId?: number;
}

const { Provider: StepProvider } = StepContext;

const SignDocumentModal: FC<ISignDocumentModal> = ({
  isOpen,
  onClose,
  document,
  module,
  personId,
}) => {
  const dispatch = useAppDispatch();

  const isPersonDocumentHTMLLoading = useRootSelector(
    selectPersonDocumentHTMLLoading(Number(personId)),
  );

  const isPersonDocumentHTMLPrinting = useCombinePrintLoading(isPersonDocumentHTMLLoading);
  const onConfirmSignDocument = () => {
    if (
      personId &&
      document?.get('type') === DocumentType.Waiver &&
      module === PeakModules.FrontDesk
    ) {
      dispatch(
        actions.resolvePersonUnsignedWaiver(
          personId,
          document?.get('id'),
          AlertCondition.UnsignedWaiver,
        ),
      );
    }
    onClose();
  };

  return (
    <DialogComponent
      loading={isPersonDocumentHTMLPrinting}
      isOpen={isOpen}
      onClose={onClose}
      disableBodyPadding
      formId="contract-form"
      size={!isMobile() ? 'md' : undefined}
    >
      <StepProvider
        value={{
          onNext: onConfirmSignDocument,
        }}
      >
        <SignatureContextProvider>
          <SignContractStepContainer
            module={module}
            docId={document?.get('id')}
            type={document?.get('type')}
            title={document?.get('title')}
          />
        </SignatureContextProvider>
      </StepProvider>
    </DialogComponent>
  );
};

export default SignDocumentModal;
